import { Component } from '@angular/core';
import { IonicPage, NavParams, ViewController, AlertController } from 'ionic-angular';
import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

/**
 * Generated class for the ActivedepositPage page.
 *
 * Active 입금 안내 팝업 (2026-08-26 PDF p.8·p.9 오른쪽).
 * 신청 팝업에서 "지금 신청하기"(차감 불가) 또는 "지금 입금하기"(갱신 실패) 를 눌렀을 때 뜬다.
 *
 * 입금 주소·금액은 두 경로 중 하나로 들어온다:
 *   1) navParams `deposit` - config/dashboard 의 active_popup_address /
 *      active_popup_amount (2026-08-27 백엔드 확정. wallet.ts:_init 참고)
 *   2) 위가 없으면 이 페이지가 직접 `deposit/binance` 를 호출한다
 *      (apply.ts:94 가 쓰는 것과 같은 USDT(BSC) 입금 주소 엔드포인트)
 */

@IonicPage()
@Component({
    selector: 'page-activedeposit',
    templateUrl: 'activedeposit.html',
})
export class ActivedepositPage {

    api_key: string;
    version: string;
    language: string;

    address: string = '';
    amount: string = '30';
    unit: string = 'USDT';
    asset: string = 'BSC';
    network: string = 'BNB Smart Chain (BEP20)';

    // 주소를 못 받았을 때 주소 자리에 대신 띄울 안내. 빈 칸을 그대로
    // 보여주면 고장난 화면이 된다.
    addressError: string = '';

    texts: any = {};
    errText: string = '';

    constructor(
        public navParams: NavParams,
        public viewCtrl: ViewController,
        public alertCtrl: AlertController,
        private clipboard: Clipboard,
        private http: HttpService
    ) {
        let deposit = navParams.get('deposit') || {};
        if (deposit.address) this.address = deposit.address;
        if (deposit.amount) this.amount = deposit.amount;
        if (deposit.unit) this.unit = deposit.unit;
        if (deposit.asset) this.asset = deposit.asset;
        if (deposit.network) this.network = deposit.network;
    }

    ionViewWillEnter() {
        this.api_key = localStorage.getItem("api_key");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");

        this._get_texts();

        if (!this.address) {
            this._load_address();
        }
    }

    _get_texts() {
        let pack = JSON.parse(localStorage.getItem('lang_pack')) || {};
        this.texts = pack.active_apply_popup || {};

        // 조회 실패 안내 문구는 이 섹션에 키가 없다. 다른 화면들이 공통으로
        // 쓰는 wallet 섹션의 오류 문구를 그대로 빌린다(서버가 언어별로 내려줌).
        this.errText = (pack.wallet && pack.wallet.alertM_err) || '잠시 후 다시 시도해 주세요.';

        // 언어팩이 asset/network 를 실어 주면 그 값을 우선한다 (navParams 로 받은 값이 없을 때만).
        if (!this.navParams.get('deposit') || !this.navParams.get('deposit').asset) {
            if (this.texts.asset_name) this.asset = this.texts.asset_name;
        }
        if (!this.navParams.get('deposit') || !this.navParams.get('deposit').network) {
            if (this.texts.network_name) this.network = this.texts.network_name;
        }
    }

    _load_address() {
        let url = "deposit/binance";
        let body = JSON.stringify({
            api: this.api_key,
            language: this.language,
            version: this.version
        });
        this.http.post(url, body).then((res: any) => {
            if (res.result == "OK" && res.address) {
                this.address = res.address;
            } else {
                // 이 엔드포인트는 회원 상태에 따라 result 를 "DONOT" 으로 돌려주고
                // 주소를 안 주는 경우가 있다(기존 입금 화면 apply.ts 의 같은 분기).
                // 그때 주소 칸을 비워두면 고장난 화면이 되므로, 서버가 준 안내
                // 문구를 주소 자리에 대신 띄운다. 알림창을 겹쳐 띄우면 입금 안내
                // 자체가 가려져서 더 나쁘다.
                this.addressError = res.message || this.errText;
            }
        }, (err) => {
            this.addressError = this.errText;
        });
    }

    _copy() {
        if (!this.address) return;

        // 코르도바 앱에서는 플러그인, 웹앱(app.funtra.net)에서는 플러그인이 없으므로
        // execCommand 폴백을 쓴다 - 이 팝업은 웹앱에서도 그대로 뜬다.
        this.clipboard.copy(this.address).then(() => {
            this._copied_alert();
        }, () => {
            this._copy_fallback();
        });
    }

    _copy_fallback() {
        try {
            let el = document.createElement('textarea');
            el.value = this.address;
            el.style.position = 'fixed';
            el.style.top = '0';
            el.style.left = '0';
            el.style.opacity = '0';
            document.body.appendChild(el);
            el.focus();
            el.select();
            el.setSelectionRange(0, el.value.length);
            document.execCommand('copy');
            document.body.removeChild(el);
            this._copied_alert();
        } catch (e) {
            // 복사 자체가 막힌 환경 - 주소는 화면에 그대로 보이므로 조용히 넘어간다.
        }
    }

    _copied_alert() {
        let alert = this.alertCtrl.create({
            title: "Copy",
            message: this.address,
            buttons: ['OK']
        });
        alert.present();
    }

    _close() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/activedeposit/activedeposit.ts